import { PERFORMANCE_INDEX_REFERENCE } from "../../models/admin-paint-scheme.models";
import { getPerformanceIndexColorClasses } from "./performance-index.styles";
import { SwatchIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

const PerformanceIndexLegend = () => (
  <section
    aria-labelledby="paint-performance-index-reference-title"
    data-test="paint-performance-index-reference"
    className="w-full max-w-xl rounded-xl border border-[#D5E5E1] bg-gradient-to-br from-[#F3F9F7] to-white p-2.5 shadow-sm dark:border-gray-700 dark:from-gray-800 dark:to-gray-800/70"
  >
    <div className="flex items-center gap-2">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white text-green shadow-sm ring-1 ring-[#D5E5E1] dark:bg-gray-900 dark:ring-gray-700">
        <SwatchIcon className="h-4 w-4" aria-hidden="true" />
      </span>
      <div>
        <h2
          id="paint-performance-index-reference-title"
          className="text-[11px] font-bold text-gray-800 dark:text-gray-100"
        >
          Performance index
        </h2>
        <p className="text-[9px] leading-3 text-gray-500 dark:text-gray-400">Expected speed-loss reference</p>
      </div>
    </div>
    <div className="mt-2 grid gap-1.5 sm:grid-cols-2">
      {PERFORMANCE_INDEX_REFERENCE.map((reference) => (
        <div
          key={reference.index}
          className="flex min-h-8 items-center gap-2 rounded-lg border border-gray-200/90 bg-white/90 px-2 py-1 shadow-[0_1px_2px_rgba(15,23,42,0.05)] dark:border-gray-700 dark:bg-gray-900/80"
        >
          <span
            className={twMerge(
              "inline-flex h-5 min-w-8 shrink-0 items-center justify-center rounded-md border px-1.5 text-[10px] font-extrabold shadow-sm",
              getPerformanceIndexColorClasses(reference.index),
            )}
          >
            {reference.index}
          </span>
          <span className="text-[10px] leading-3 text-gray-600 dark:text-gray-300">{reference.description}</span>
        </div>
      ))}
    </div>
  </section>
);

export default PerformanceIndexLegend;
